import { UseApplicationsPropertyFinanceHook } from "@/hooks";
import { displayUsCents } from "@/utils";
import { ClientPropertyFinanceRow } from "../types";
import ClientPropertyFinanceTable from "../ClientPropertyFinanceTable";
import { useState } from "react";
import ClientPropertyFinanceTableHeader from "../ClientPropertyFinanceTableHeader";
import YearlyPaymentsForm from "./YearlyPaymentsForm";

interface Props {
  useApplicationsPropertyFinanceInstance: UseApplicationsPropertyFinanceHook;
}

const tableRows: Array<ClientPropertyFinanceRow> = [
  {
    label: "Insurance",
    fieldKey: "insuranceCents",
    displayFn: displayUsCents,
  },
  {
    label: "HOA",
    fieldKey: "hoaCents",
    displayFn: displayUsCents,
  },
  {
    label: "HOA Payment Frequency",
    fieldKey: "hoaPaymentFrequency",
    displayFn: (value) => value,
  },
  {
    label: "Taxes",
    fieldKey: "taxesCents",
    displayFn: displayUsCents,
  },
];

const YearlyPaymentsCard = ({ useApplicationsPropertyFinanceInstance }: Props) => {
  const isFormOpenStateInstance = useState<boolean>(false);
  const [, setIsFormOpen] = isFormOpenStateInstance;

  return (
    <ClientPropertyFinanceTable
      useApplicationsPropertyFinanceInstance={useApplicationsPropertyFinanceInstance}
      tableRows={tableRows}
      title={
        <ClientPropertyFinanceTableHeader
          FormElement={
            <YearlyPaymentsForm
              handleClose={() => setIsFormOpen(false)}
              useApplicationsPropertyFinanceInstance={useApplicationsPropertyFinanceInstance}
            />
          }
          isFormOpenStateInstance={isFormOpenStateInstance}
          title="Yearly Payments"
        />
      }
    />
  );
};

export default YearlyPaymentsCard;
